module.exports = __webpack_public_path__ + "img/jtb-avatar-7553.2198b34e.jpg";